import React from "react";
import PartyPage from "@/pages/sales/PartyPage";
export default function Suppliers() { return <PartyPage kind="supplier" />; }
